import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { GetGroupGeneralDataPayload } from "../../payload/GetGroupGeneralData/GetGroupGeneralDataPayload";

const getGroupGeneralDataFetch = (state: GroupsState, action: PayloadAction<GetGroupGeneralDataPayload>) => {
    state.isLoading = true
}

export default getGroupGeneralDataFetch;